
export function FreezeAndOverrideDate(milliseconds) {
  // Store the real current time for offset calculations
  const realNow = new Date().getTime();
  const timeOffset = realNow - milliseconds;

  // Store the offset globally for use in chart tooltips
  window.DEMO_TIME_OFFSET = timeOffset;
  class NewDate extends Date {
    constructor(a, b, c, d, e, f, g) {
      var x;
      switch (arguments.length) {
        case 0:
          super(milliseconds);
          break;
        case 1:
          super(a);
          break;
        case 2:
          super(a, b);
          break;
        case 3:
          super(a, b, c);
          break;
        case 4:
          super(a, b, c, d);
          break;
        case 5:
          super(a, b, c, d, e);
          break;
        case 6:
          super(a, b, c, d, e, f);
          break;
        default:
          super(a, b, c, d, e, f, g);
      }
      return x;
    }

    static now() {
      return milliseconds;
    }
  }

  window.Date = NewDate;
  window.DisplayDate = Date;
  window.DEMO_FROZEN_TIME = true;
}
